import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Puis-je être congédié pour alcool au volant?"
            description="Vous avez récemment été reconnu coupable de conduite avec les facultés affaiblies? Avocats Alcool au Volant vous indique s’il est possible pour votre employeur de vous congédier dans cette situation."
            fr={undefined}
            lawType="labour"
            specialtyText="spécialisé en droit du travail">
            <p>
                En principe, il ne sera pas possible pour un employeur de vous
                congédier si vous êtes reconnu coupable de conduite avec les
                facultés affaiblies. Toutefois, ce droit a tout de même ses
                limites.
            </p>
            <ul>
                <li>
                    <strong>
                        En effet, l’employeur ne peut pas vous congédier si
                        l’infraction n’a aucun lien avec votre emploi ou si vous
                        avez obtenu le pardon.
                    </strong>
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Mon employeur peut-il me congédier pour alcool au volant?"
                    alt=""
                />
            </p>
            <p>
                Ces règles s’appliquent au congédiement, mais également au
                moment où vous appliquez pour un emploi.{' '}
            </p>
            <p>
                <strong>
                    Avocats Alcool au Volant vous aide à mieux comprendre les
                    conséquences de la conduite avec les facultés affaiblies sur
                    votre emploi!
                </strong>
            </p>
            <h2>Quelles sont les protections offertes par la loi?</h2>
            <p>
                En vertu de l’
                <Link to="https://www.legisquebec.gouv.qc.ca/fr/document/lc/c-12#se:18_2">
                    article 18.2
                </Link>{' '}
                de la Charte des droits et libertés de la personne, vous ne
                pourrez être congédié si vous êtes reconnu coupable que si
                l’infraction a un lien avec votre emploi:
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>18.2.</strong> Nul ne peut congédier,
                            refuser d’embaucher ou autrement pénaliser dans le
                            cadre de son emploi une personne du seul fait
                            qu’elle a été déclarée coupable d’une infraction
                            pénale ou criminelle, si cette infraction n’a aucun
                            lien avec l’emploi ou si cette personne en a obtenu
                            le pardon.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Par conséquent, un employeur ne peut pas congédier un employé
                sur la base qu’il ait été reconnu coupable d’avoir commis une
                infraction pénale ou criminelle. Cette règle a tout de même ses
                limites.{' '}
            </p>
            <p>
                En effet, l’employeur pourra dans{' '}
                <strong>deux situations précises</strong> procéder au
                congédiement de son employé après qu’il ait été reconnu
                coupable:
            </p>
            <ol>
                <li>
                    Lorsqu’il y a un lien entre l’infraction et l’emploi et
                    qu’il n’a pas obtenir de pardon, ou
                </li>
                <li>
                    Lorsque l’employé est incarcéré et qu’il est congédié en
                    raison de son indisponibilité.{' '}
                </li>
            </ol>
            <p>
                Par exemple, si vous êtes camionneur et que vous êtes reconnu
                coupable de conduite avec les facultés affaiblies, il est
                probable que vous soyez congédié. Après tout, vous ne pourrez
                plus conduire de véhicule.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Comment obtenir mon permis après qu’il ait été révoqué?"
                    alt=""
                />
            </p>
            <p>
                Toutefois, un ouvrier d’entretien pour une école ne pourra pas
                nécessairement être congédié pour le simple fait d’être reconnu
                coupable d’alcool au volant. S’il doit purger une peine
                d’emprisonnement,{' '}
                <strong>
                    l’employeur pourra le congédier pour son absence
                </strong>
                .
            </p>
            <p>
                En bref, la majorité des employés ne peuvent pas être congédiés
                en raison d’une <strong>déclaration de culpabilité</strong> pour
                alcool au volant puisqu’il n’y a pas de lien avec leur emploi.{' '}
            </p>
            <p>
                De plus, ce ne sont pas toutes les personnes coupables d’alcool
                au volant qui vont purger une peine d’emprisonnement. Ce n’est
                qu’
                <Link to="https://avocatsalcoolauvolant.ca/recidive-alcool-volant/">
                    en cas de récidive
                </Link>{' '}
                ou si vous blessez une personne en raison de votre conduite.{' '}
            </p>
            <p>
                <strong>
                    Accusé de conduite avec les facultés affaiblies? Avocats
                    Alcool au Volant vous permet de trouver l'avocat qu’il vous
                    faut gratuitement!
                </strong>
            </p>
            <h2>
                Permis de conduire restreint – Comment conserver mon emploi?
            </h2>
            <p>
                Lorsque votre permis de conduire est révoqué en raison de
                l’alcool au volant, il vous est toujours possible de demander un
                permis de conduire restreint afin de pouvoir continuer à
                travailler.{' '}
            </p>
            <p>
                En effet, si vous emploi vous demande d’être au volant d’un
                véhicule, il est tout à fait normal que vous ayez à avoir un
                permis de conduire valide. Toutefois, un juge peut révoquer
                votre permis si vous êtes coupable de conduites avec les
                facultés affaiblies.{' '}
            </p>
            <p>
                La durée de l’interdiction de conduire varie du degré de
                l’infraction commise, mais également de vos antécédents. Durant
                la période d’interdiction, vous avez généralement une
                interdiction stricte de conduire un véhicule.
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Qu’est-ce qu’un permis de conduire restreint?"
                    alt=""
                />
            </p>
            <p>
                Grâce au permis de conduire restreint, vous pourrez continuer à
                conduire tant que votre véhicule est muni d’un{' '}
                <strong>antidémarreur éthylométrique</strong>. Pour démarrer
                votre véhicule, vous devrez utiliser l’antidémarreur afin d’être
                certain que vous n’avez pas d’alcool dans votre sang.{' '}
            </p>
            <p>
                Même avec un permis de conduire restreint, il y aura une{' '}
                <strong>période minimale d’interdiction de conduire</strong> qui
                varie selon le nombre d’infractions commises:
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Infraction</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Période minimale d’interdiction</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Première infraction </p>
                    </td>
                    <td>
                        <p>Période déterminée par le juge</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Deuxième infraction</p>
                    </td>
                    <td>
                        <p>3 mois après le jugement</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Troisième infraction ou plus</p>
                    </td>
                    <td>
                        <p>6 mois après le jugement</p>
                    </td>
                </tr>
            </table>
            <p>
                <strong>
                    Que se passe-t-il si je conduis pendant la période
                    d’interdiction?
                </strong>{' '}
                Il s’agit d’une infraction criminelle. Ainsi, si vous êtes
                intercepté au volant d’un véhicule, vous pourrez devoir purger
                une peine d’emprisonnement.
            </p>
            <p>
                Pour obtenir votre permis de conduire restreint, il faudra,
                après la fin de la période minimale d’interdiction, louer un
                antidémarreur approuvé par la SAAQ et se présenter à l’un des
                bureaux de la SAAQ avec le contrat de location.{' '}
            </p>
            <h2>
                Comment obtenir un nouveau permis après être reconnu coupable
                d’alcool au volant?
            </h2>
            <p>
                Lorsqu’une période d’interdiction de conduire prend fin, vous
                n’allez pas nécessairement récupérer votre permis
                automatiquement. S’il a été révoqué, il n’existe tout simplement
                plus. Il faudra donc obtenir <strong>un nouveau permis</strong>.
            </p>
            <p>
                La principale condition pour{' '}
                <Link to="https://avocatsalcoolauvolant.ca/recuperer-permis-apres-alcool-volant/">
                    obtenir un nouveau permis
                </Link>{' '}
                est de réussir une évaluation faite dans un{' '}
                <strong>
                    centre de réadaptation pour les personnes alcooliques ou
                    toxicomanes.{' '}
                </strong>
                Ce test permet d’évaluer les risques de récidives.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Mon employeur peut-il me congédier si je vais en prison?"
                    alt=""
                />
            </p>
            <p>
                Dans certains cas, la SAAQ peut vous demander de passer à
                nouveau les tests théoriques et pratiques requis pour obtenir le
                permis de conduite. Ce sera le cas si la suspension dure plus de
                3 ans.{' '}
            </p>
            <p>
                Même si vous recevez un nouveau permis, celui-ci peut être
                accompagné de plusieurs conditions que la SAAQ considère comme
                nécessaires afin d’assurer la protection du public. La condition
                principale est l’obligation d’avoir un antidémarreur dans le
                véhicule.{' '}
            </p>
            <p>
                <strong>
                    Vous êtes sur le point de perdre votre permis de conduire?
                    Avocats Alcool au Volant vous permet de trouver un avocat
                    gratuitement!
                </strong>
            </p>
            <h2>
                Vous avez perdu votre emploi en raison de l’alcool au volant?
                Avocats Alcool au Volant est là pour vous!
            </h2>
            <p>
                Par conséquent, un employeur ne pourra congédier un employé
                coupable d’alcool au volant que si l’infraction a un lien avec
                son emploi. Cela ne veut toutefois pas dire que l’employeur ne
                va pas tenter de mettre fin à la relation d’emploi.
            </p>
            <p>
                Si vous n’êtes pas certain de savoir si votre employeur peut
                vous congédier, la meilleure chose à faire est de faire appel à
                un avocat spécialisé en droit du travail. Grâce à ce dernier,
                vous pourrez potentiellement conserver votre emploi.
            </p>
            <p>
                <strong>
                    Pour trouver le bon avocat, vous n’avez qu’à remplir le
                    formulaire en ligne d’Avocats Alcool au Volant et le tour
                    est joué!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "congediement-alcool-volant/employeur-congédiement-alcool.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "congediement-alcool-volant/permis-conduite-revoque.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "congediement-alcool-volant/permis-conduire-restreint.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "congediement-alcool-volant/employeur-congédiement-emprisonnement.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
